import axios from 'axios';

const sendEmail = async (fullname, email, phoneno, subject, message) => {
  return axios({
    method: 'post',
    url: '/api/send-mail',
    data: {
      fullname: fullname,
      email: email,
      phoneno: phoneno,
      subject: subject,
      message: message,
    },
  });
};

export default sendEmail;